// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',
  newPassword: '/new-password',
  registrationComplete: '/registration-complete',
  userInactive: '/user-inactive',
  verification: '/verification',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  main: path(ROOTS_DASHBOARD, '/main'),
  paymentStatus: (status: string) => path(ROOTS_DASHBOARD, `/main/payment/${status}`),
  advertisers: {
    list: path(ROOTS_DASHBOARD, '/advertisers'),
    new: path(ROOTS_DASHBOARD, '/advertisers/new'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/advertisers/${name}/edit`),
  },
  report: path(ROOTS_DASHBOARD, '/report'),
  reportRequests: path(ROOTS_DASHBOARD, '/reportRequests'),
  reportFeedRate: path(ROOTS_DASHBOARD, '/reportFeedRate'),
  reportClickRate: path(ROOTS_DASHBOARD, '/reportClickRate'),
  profile: path(ROOTS_DASHBOARD, '/profile'),
  publishers: {
    list: path(ROOTS_DASHBOARD, '/publishers'),
    new: path(ROOTS_DASHBOARD, '/publishers/new'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/publishers/${name}/edit`),
  },
  sitesAll: path(ROOTS_DASHBOARD, '/sites/all'),
  sites: {
    list: (pubParam: string) => path(ROOTS_DASHBOARD, `/publishers/${pubParam}`),
    new: (pubId: string) => path(ROOTS_DASHBOARD, `/publishers/${pubId}/sites/new`),
    edit: (pubId: string, siteId: string) =>
      path(ROOTS_DASHBOARD, `/publishers/${pubId}/sites/${siteId}/edit`),
  },
  campaignsAll: path(ROOTS_DASHBOARD, '/campaigns/all'),
  campaigns: {
    list: (advParam: string) => path(ROOTS_DASHBOARD, `/advertisers/${advParam}`),
    new: (advId: string) => path(ROOTS_DASHBOARD, `/advertisers/${advId}/campaigns/new`),
    edit: (advId: string, campaignId: string) =>
      path(ROOTS_DASHBOARD, `/advertisers/${advId}/campaigns/${campaignId}/edit`),
  },
  users: {
    list: path(ROOTS_DASHBOARD, '/users'),
    new: path(ROOTS_DASHBOARD, '/users/new'),
    edit: (userId: string) => path(ROOTS_DASHBOARD, `/users/${userId}/edit`),
  },
  audit: (section: string | undefined) =>
    path(ROOTS_DASHBOARD, `/audit/${section ? `${section}` : ''}`),
  settings: path(ROOTS_DASHBOARD, '/settings'),
  api: path(ROOTS_DASHBOARD, '/api'),
  finance: path(ROOTS_DASHBOARD, '/finance'),
};
